// labels

export const marketLabels = {
    ID: 'INDONESIA',
    PH: 'PHILIPINES',
    CZ: 'Czech Republic',
    US: 'United States'
};
export const categoryLabels = {
    CC: 'CONVENTIONAL CIGARETTES',
};
export const brandLabels = {
    MARLBORO: 'MARLBORO',
    MAGNUM: 'MAGNUM',
};
